import { render, staticRenderFns } from "./HeartysanChatPage.vue?vue&type=template&id=7e4fddd8&scoped=true"
import script from "./HeartysanChatPage.vue?vue&type=script&lang=js"
export * from "./HeartysanChatPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4fddd8",
  null
  
)

export default component.exports